// extracted by mini-css-extract-plugin
export default {"root":"Error_root__xlDyH","explain":"Error_explain__0fq15"};